import React, { useEffect } from "react";
import "./BaseInput.scss";
import { useSelector, useDispatch } from "react-redux";
import { setForm } from "../../store/slices/invoiceSlice";
import { useState, useCallback } from "react";
import { getChildrenId } from "../../services/invoice";
import { checkValidIdForExporting } from "../../services/invoice";
import SmallLoader from "../SmallLoader/SmallLoader";

export default function AhamoveIdInput({ label, inputId, onClickDropdown, setErrorStatus }) {
  const dispatch = useDispatch();
  const initialValue = useSelector(state => state.invoice.invoiceForm[inputId]);
  const token = useSelector(state => state.app.token);
  const [isLoading, setIsLoading] = useState(false);

  function debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  async function getData(userId) {
    setIsLoading(true);
    try {
      setErrorStatus(false);
      let validStatus = await checkValidIdForExporting({ userId, token });
      setErrorStatus(validStatus.data);
      if (validStatus.data) {
        let { data } = await getChildrenId({ userId, token });
        let user_arr = [userId, ...data];
        let user_id = JSON.stringify(user_arr);
        dispatch(setForm({ field: "childAhamoveId", value: user_arr }));
        dispatch(setForm({ field: "userAhamoveId", value: user_id }));
      }

      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  }

  const debounceGetChildId = useCallback(debounce((nextValue) => getData(nextValue), 1000), []);

  useEffect(() => {
    async function validDate() {
      let validStatus = await checkValidIdForExporting({ userId: initialValue, token });
      setErrorStatus(validStatus.data);
    }

    validDate();
  }, []);
  return (
    <div className="input-border field px-3 pt-1 relative">
      <input type="text" id={inputId}
             placeholder=" " key={inputId} value={initialValue}
             onInput={(e) => {
               setErrorStatus(false);
               debounceGetChildId(e.target.value);
               dispatch(setForm({ field: inputId, value: e.target.value }));
             }}
      />
      <label className={"text-gray-600 text-xs normal-case"}
             htmlFor={inputId}>{label}</label>
      <div className={"absolute right-2 top-1/3"}>
        {
          isLoading ? (
            <SmallLoader />
          ) : (
            <img className={"cursor-pointer"} onClick={onClickDropdown} src={`img/arrow-down.png`} alt="" />
          )
        }
      </div>
    </div>
  );
}
